import { render, staticRenderFns } from "./BulkWorkers.vue?vue&type=template&id=12915a85&"
import script from "./BulkWorkers.vue?vue&type=script&lang=js&"
export * from "./BulkWorkers.vue?vue&type=script&lang=js&"
import style0 from "./BulkWorkers.vue?vue&type=style&index=0&id=12915a85&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports